
import {defineComponent, ref, onMounted} from 'vue'
import {variantTypes} from "@/types/types"
/// <reference types="./../types/EventBus" />

export default defineComponent({
    name: 'Single',
    setup() {
        const variants = ref<variantTypes[]>(window.variantData);
        const selectedVariant = ref<variantTypes>(variants.value[0]);

        const changeVariant = (variant: variantTypes) => {
            selectedVariant.value = variant;
            EventBus.getInstance().dispatchEvent('productVariantChanged', variant);
            window.location.hash = '#' + variant.id;
        }

        onMounted(() => {
            const hashVariant = variants.value.find(variant => variant.id === +window.location.hash.substring(1));
            if (window.location.hash && hashVariant) {
                selectedVariant.value = hashVariant;
                (async() => {
                    while (!Object.prototype.hasOwnProperty.call(window,"EventBusInstance"))
                        await new Promise(resolve => setTimeout(resolve, 400));

                    EventBus.getInstance().dispatchEvent('productVariantChanged', hashVariant);
                })();
            }
        })

        return {
            variants,
            selectedVariant,
            changeVariant
        }
    }
})

